var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, AlertTitle, Collapse, Grow } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { theme } from './theme';
var AlertComponent = function (_a) {
    var title = _a.title, type = _a.type, style = _a.style, message = _a.message, component = _a.component, _b = _a.show, show = _b === void 0 ? true : _b, onAnimationEnd = _a.onAnimationEnd, _c = _a.animationDuration, animationDuration = _c === void 0 ? 200 : _c;
    var _d = useState(show), isVisible = _d[0], setIsVisible = _d[1];
    var updStyle = __assign(__assign({}, theme.wrapper), style);
    useEffect(function () {
        // Встановлюємо стан одразу, без затримки
        setIsVisible(show);
    }, [show]);
    var handleAnimationEnd = function () {
        if (!isVisible && onAnimationEnd) {
            onAnimationEnd();
        }
    };
    var formatMessageWithLinks = function (text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.split('\n').map(function (line, lineIndex) {
            var parts = line.split(urlRegex);
            return (_jsxs(React.Fragment, { children: [parts.map(function (part, partIndex) {
                        if (urlRegex.test(part)) {
                            return (_jsx("a", { href: part, target: "_blank", rel: "noopener noreferrer", style: {
                                    color: 'inherit',
                                    textDecoration: 'underline',
                                    cursor: 'pointer',
                                }, children: part }, partIndex));
                        }
                        return part;
                    }), _jsx("br", {})] }, lineIndex));
        });
    };
    // Функція для обробки HTML тегів (для локалізації)
    var formatMessageWithHTML = function (text) {
        // Перевіряємо чи містить текст HTML теги
        if (text.includes('<') && text.includes('>')) {
            return (_jsx("div", { dangerouslySetInnerHTML: { __html: text }, style: {
                    lineHeight: '1.5',
                } }));
        }
        // Якщо HTML тегів немає, використовуємо звичайне форматування
        return formatMessageWithLinks(text);
    };
    var formattedMessage = typeof message === 'string' ? formatMessageWithHTML(message) : message;
    return (_jsx(Grow, { in: isVisible, timeout: animationDuration * 0.5, style: { transformOrigin: '0 0 0' }, easing: {
            enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
            exit: 'cubic-bezier(0.4, 0, 1, 1)',
        }, children: _jsx(Collapse, { in: isVisible, timeout: animationDuration, orientation: "vertical", collapsedSize: 0, easing: {
                enter: 'cubic-bezier(0.4, 0, 0.2, 1)',
                exit: 'cubic-bezier(0.4, 0, 1, 1)',
            }, onExited: handleAnimationEnd, style: { position: 'relative', zIndex: 2 }, children: _jsxs(Alert, { severity: type, sx: updStyle, icon: false, children: [title && _jsx(AlertTitle, { children: title }), formattedMessage, " ", component] }) }) }));
};
export default AlertComponent;
